// Global
import { GetStaticComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';

// Lib
import { ComponentProps } from 'lib/component-props';
import graphQLClientFactory from 'lib/graphql-client-factory';

// Local
import { gql } from 'graphql-request';
import { IngredientData } from '../Accordion/Accordion';

export type HeroIngredientProps = ComponentProps & { ingredientData?: Ingredient };

type Ingredient = {
  item: IngredientData;
};

const HeroIngredient = (props: HeroIngredientProps): JSX.Element => {
  console.log('ingredientData:', props.ingredientData);
  const { item } = props?.ingredientData || {};

  if (!item) return <>Ingredient Hero</>;

  return (
    <div data-component="authorable/heroes/ingredienthero">
      <div>
        <p>
          <strong>Title:</strong> {item?.title?.value || 'No Title Available'}
        </p>
        <p>
          <strong>Definition:</strong>
          {item.definition?.value || 'No Definition Available'}
        </p>
      </div>
    </div>
  );
};

export default HeroIngredient;

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const getStaticProps: GetStaticComponentProps = async (
  rendering: any,
  layoutData: any,
  context: any
) => {
  const graphQLClient = graphQLClientFactory({});
  const ingredientPath = context?.params?.requestPath ?? null;
  let data = null;
  if (ingredientPath) {
    const basePath = '/sitecore/content/Dart/Shared/Data/Ingredient Information/Ingredients';
    let attempts = 0;
    let isValidItem = false;

    const itemName = ingredientPath?.pop();
    let folderPath = '';

    if (itemName) {
      const firstChar = itemName.charAt(0);
      folderPath = !isNaN(Number(firstChar)) ? '0' : firstChar;

      do {
        attempts++;
        const itemPath = basePath + '/' + folderPath + '/' + itemName;
        data = await graphQLClient.request<Ingredient>(query, {
          path: itemPath,
          params: rendering.params,
          language: layoutData?.sitecore?.context?.language,
        });
        isValidItem = !!data?.item;
        folderPath = 'Hashtag';
      } while (!isValidItem && attempts < 2);
    }
  }

  return {
    context: layoutData?.sitecore?.route,
    ingredientData: data,
  };
};

const query = gql`
  query ($path: String!, $language: String!) {
    item(path: $path, language: $language) {
      name
      ... on Ingredient {
        title {
          value
        }
        definition {
          value
        }
        active {
          value
        }
      }
    }
  }
`;
